import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { TRANSLATIONS } from "../lib/i18n";

const LanguageContext = createContext(null);
const STORAGE_KEY = "icc_language";
const SUPPORTED = ["en", "ar", "ur", "de", "fr"];
// Languages that should render right-to-left
const RTL_LANGS = ["ar", "ur"];

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (SUPPORTED.includes(stored)) return stored;
    } catch (e) {
      // ignore
    }
    return "en";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = RTL_LANGS.includes(lang) ? "rtl" : "ltr";
  }, [lang]);

  const setLanguage = useCallback((next) => {
    if (!SUPPORTED.includes(next)) return;
    setLang(next);
    localStorage.setItem(STORAGE_KEY, next);
  }, []);

  // Cycle EN → AR → UR → EN
  const toggleLanguage = useCallback(() => {
    const idx = SUPPORTED.indexOf(lang);
    const next = SUPPORTED[(idx + 1) % SUPPORTED.length];
    setLanguage(next);
  }, [lang, setLanguage]);

  const t = useCallback(
    (key) => TRANSLATIONS[lang]?.[key] ?? TRANSLATIONS.en[key] ?? key,
    [lang]
  );

  const value = {
    lang,
    setLanguage,
    toggleLanguage,
    t,
    isRTL: RTL_LANGS.includes(lang),
    supported: SUPPORTED,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
